import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["amount"],
  _excluded2 = ["rangeDelimiter"],
  _excluded3 = ["startingAtAppendix"],
  _excluded4 = ["rangeDelimiter"],
  _excluded5 = ["rangeDelimiter", "displayZeroCost"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNaN from 'lodash/isNaN';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import _max from 'lodash/max';
import _min from 'lodash/min';
import { isMoneyString, formatCurrency } from '../../../utils/currency';
import { FIRST_PRICE_DISPLAY_TYPE, RANGE_PRICE_DISPLAY_TYPE, ALL_PRICE_DISPLAY_TYPE, ZERO_PRICE_LABEL } from '../constants';
import { PriceRangeSettingsPropTypeDefault } from '../types';
export function isPriceLabel(amount) {
  if (_isNumber(amount)) {
    return false;
  }
  return !isMoneyString(amount);
}
export function pricesHaveLabels(prices) {
  if (_isEmpty(prices)) {
    return false;
  }
  return prices.some(function (_ref) {
    var amount = _ref.amount;
    return isPriceLabel(amount);
  });
}
export function createLabeledPriceRangeDisplay(prices, delimiter) {
  return prices.map(function (_ref2) {
    var amount = _ref2.amount;
    return amount;
  }).join(delimiter);
}
export function createPrices(prices, priceKey) {
  if (_isEmpty(prices)) {
    return [];
  }
  return prices.map(function (price) {
    return _objectSpread(_objectSpread({}, price), {}, {
      amount: _get(price, priceKey)
    });
  }).filter(function (_ref3) {
    var amount = _ref3.amount;
    return !_isNil(amount);
  });
}
export function normalizePrices(prices) {
  if (_isEmpty(prices)) {
    return [];
  }
  return prices.map(function (_ref4) {
    var amount = _ref4.amount,
      restPrice = _objectWithoutProperties(_ref4, _excluded);
    if (_isString(amount)) {
      var parsedPrice = parseFloat(amount);
      var isValidPrice = !_isNaN(parsedPrice);
      return _objectSpread(_objectSpread({}, restPrice), {}, {
        amount: isValidPrice ? parsedPrice : 0
      });
    }
    return _objectSpread(_objectSpread({}, restPrice), {}, {
      amount: amount
    });
  });
}
export function getPriceRange(prices) {
  if (_isEmpty(prices)) {
    return [0, 0];
  }
  var amounts = prices.map(function (_ref5) {
    var amount = _ref5.amount;
    return amount;
  });
  if (amounts.length === 1) {
    return [amounts[0], null];
  }
  return [_min(amounts), _max(amounts)];
}
export function getPriceDisplay(price) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref6$displayZeroCost = _ref6.displayZeroCost,
    displayZeroCost = _ref6$displayZeroCost === void 0 ? false : _ref6$displayZeroCost,
    _ref6$precision = _ref6.precision,
    precision = _ref6$precision === void 0 ? 2 : _ref6$precision,
    _ref6$hideCurrencySig = _ref6.hideCurrencySign,
    hideCurrencySign = _ref6$hideCurrencySig === void 0 ? false : _ref6$hideCurrencySig;
  if (isPriceLabel(price)) {
    return price;
  }
  var parsedPrice = +price;
  if (parsedPrice === 0 && !displayZeroCost) {
    return '';
  }
  return formatCurrency(parsedPrice, precision, {
    hideCurrencySign: hideCurrencySign
  });
}
export function displayAllPrices(prices, settings) {
  var rangeDelimiter = settings.rangeDelimiter,
    restSettings = _objectWithoutProperties(settings, _excluded2);
  return prices.map(function (_ref7) {
    var amount = _ref7.amount;
    return getPriceDisplay(amount, restSettings);
  }).join(rangeDelimiter);
}
export function displayFirstPrice(prices, settings) {
  var startingAtAppendix = settings.startingAtAppendix,
    restSettings = _objectWithoutProperties(settings, _excluded3);
  var _getPriceRange = getPriceRange(prices),
    _getPriceRange2 = _slicedToArray(_getPriceRange, 2),
    minPrice = _getPriceRange2[0],
    maxPrice = _getPriceRange2[1];
  var minPriceDisplay = getPriceDisplay(minPrice, restSettings);
  return maxPrice ? "".concat(minPriceDisplay).concat(startingAtAppendix) : '';
}
export function displayPriceRange(prices, settings) {
  var rangeDelimiter = settings.rangeDelimiter,
    restSettings = _objectWithoutProperties(settings, _excluded4);
  var _getPriceRange3 = getPriceRange(prices),
    _getPriceRange4 = _slicedToArray(_getPriceRange3, 2),
    minPrice = _getPriceRange4[0],
    maxPrice = _getPriceRange4[1];
  var minPriceDisplay = getPriceDisplay(minPrice, restSettings);
  var maxPriceDisplay = getPriceDisplay(maxPrice, restSettings);
  if (minPriceDisplay === maxPriceDisplay) {
    return minPriceDisplay;
  }
  return maxPrice ? "".concat(minPriceDisplay).concat(rangeDelimiter).concat(maxPriceDisplay) : '';
}
export function handleDefaultPriceDisplay(prices, settings) {
  var rangeDelimiter = settings.rangeDelimiter,
    displayZeroCost = settings.displayZeroCost,
    restSettings = _objectWithoutProperties(settings, _excluded5);
  var _getPriceRange5 = getPriceRange(prices),
    _getPriceRange6 = _slicedToArray(_getPriceRange5, 2),
    minPrice = _getPriceRange6[0],
    maxPrice = _getPriceRange6[1];
  if (minPrice === 0 && maxPrice === 0) {
    return rangeDelimiter;
  }
  var formattedPrice = formatCurrency(minPrice, restSettings);
  if (formattedPrice === ZERO_PRICE_LABEL && displayZeroCost) {
    return formattedPrice;
  }
  if (formattedPrice === ZERO_PRICE_LABEL && !displayZeroCost) {
    return '';
  }
  return formattedPrice;
}
export function displayPriceBasedOnType(prices, settings) {
  var _displayHandlers;
  var displayType = settings.displayType;
  var displayHandlers = (_displayHandlers = {}, _defineProperty(_displayHandlers, ALL_PRICE_DISPLAY_TYPE, function () {
    return displayAllPrices(prices, settings);
  }), _defineProperty(_displayHandlers, FIRST_PRICE_DISPLAY_TYPE, function () {
    return displayFirstPrice(prices, settings);
  }), _defineProperty(_displayHandlers, RANGE_PRICE_DISPLAY_TYPE, function () {
    return displayPriceRange(prices, settings);
  }), _displayHandlers);
  var handler = displayHandlers[displayType];
  return handler ? handler() : handleDefaultPriceDisplay(prices, settings);
}
export function getPriceRangeDisplay(prices, settings) {
  var finalSettings = _objectSpread(_objectSpread({}, PriceRangeSettingsPropTypeDefault), settings);
  if (_isEmpty(prices)) {
    return '';
  }
  var normalizedPrices = normalizePrices(prices);
  return displayPriceBasedOnType(normalizedPrices, finalSettings);
}